<template>
    <div class="approach-temp-wrap">
        <Title v-if="page">
            <h2>Approach</h2>
        </Title>

        <div class="page-inner" v-if="page && page.blocks.length !== 0">
            <div class="ui-enter">
                <div class="item-list" v-if="page && page.blocks.length !== 0">
                    <div
                        class="item"
                        style="width: 100%"
                        v-for="(item, index) in page.blocks"
                        :class="'item-' + (index + 1)"
                        :key="index"
                        ref="item"
                        @click="anime(index)"
                    >
                        <div class="box">
                            <h3 v-if="item.title" v-html="item.title"></h3>
                            <p
                                v-if="item.text"
                                :class="{
                                    text: true,
                                    'large-text': item.text_style === 'large',
                                    'centered-text':
                                        item.text_alignment === 'center'
                                }"
                                v-html="
                                    item.text.replace(
                                        /(?:\r\n|\r|\n)/g,
                                        '<br />'
                                    )
                                "
                            ></p>
                            <Lottie
                                v-if="
                                    item.animations.mobile_animation &&
                                        item.animations.desktop_animation
                                "
                                :animation="item.animations"
                            />
                            <ImageGrid
                                v-if="item.images"
                                :images="item.images"
                                class="image-grid approach-image-grid"
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Loading v-if="$store.state.is_loading" class="static" />
            <RelatedItems
                v-if="
                    page &&
                        page.related_items &&
                        page.related_items.length !== 0
                "
                :topSpacing="false"
                :list="page.related_items"
            />
        </div>
    </div>
</template>
<script>
// import shuffle from '@/utils/Shuffle';
import Title from "@/components/ui/Title.vue";
import List from "@/components/ui/List.vue";
import NoResults from "@/components/ui/NoResults.vue";
import Item from "@/components/Item.vue";
import Loading from "@/components/Loading.vue";
import RelatedItems from "@/components/RelatedItems.vue";
import ImageGrid from "../components/ImageGrid.vue";
import Lottie from "../components/Lottie.vue";

export default {
    name: "approach",

    data() {
        return {
            page: false
        };
    },

    components: {
        Title,
        List,
        Item,
        Loading,
        NoResults,
        RelatedItems,
        ImageGrid,
        Lottie
    },

    watch: {
        "$route.params": {
            handler(params) {
                this.fetchData(params);
            },

            immediate: true
        }
    },

    methods: {
        fetchData(params) {
            this.page = false;
            // this.current_page_id = false;

            this.$ajax.get("pages?slug=approach").then(res => {
                this.page = res.data[0];
                document.title =
                    window.globals.site_title +
                    " — " +
                    this.$decode(res.data[0].title.rendered);
                this.$store.state.is_loading = false;
            });
        }
    }

    // mounted() {

    // },
};
</script>

<style lang="scss">
.desk-hidden {
    display: none;
}

.approach-temp-wrap {
    overflow: hidden;

    .page-title {
        width: 100%;
        box-sizing: border-box;
        margin: 0 0 1em;
    }

    .box {
        display: flex;
        flex-direction: column;
        gap: var(--padding);
    }

    .approach-image-grid .columns-container {
        justify-content: center;
    }

    .item-list {
        position: relative;
        display: flex;
        flex-direction: column;
        padding-top: 0;

        .item {
            padding: var(--padding);
            min-height: 25rem;
            box-sizing: border-box;

            // text-align: center;
            // cursor: pointer;

            h3 {
                font-size: var(--title-size);
                padding-bottom: var(--padding);
                text-align: center;
            }

            .text {
                font-size: var(--large-size);
            }

            .text.large-text {
                font-size: var(--large-size);
            }

            .text.centered-text {
                text-align: center;
            }
        }
    }
}

@media only screen and (max-width: 1200px) {
    .approach-temp-wrap {
        .page-inner {
            padding: 0 var(--margin);
        }
    }
}

@media only screen and (max-width: 767px) {
    .approach-temp-wrap {
        .page-title {
            margin: 0 var(--padding) 1em;
        }

        .desk-hidden {
            display: block;
        }

        .item-list {
            padding-top: 0;

            .item {
                width: 100%;
                margin: 0 auto var(--padding);
                padding: 0;

                h3 {
                    text-align: left;
                    text-transform: none;
                    padding-bottom: var(--margin);
                    font-size: var(--large-size);
                }

                .text {
                    font-size: var(--base-size);
                }

                .text.large-text {
                    font-size: var(--large-size);
                }

                .text.centered-text {
                    text-align: left;
                }
            }
        }
    }
}
</style>
